module.exports = "\n<app-header></app-header>\n<router-outlet style=\"\"> </router-outlet>\n<app-footer></app-footer>"